/**
 * `orange-subnav` — the breadcrumb strip. Prototype `crumbLine()`.
 *
 * Every crumb but the last is a link in the real eShop and goes nowhere here, so
 * like the masthead nav they are `<span>`s rather than dead links — see the note in
 * `masthead.component.ts`. The last crumb carries `aria-current="page"`.
 *
 * The `/` separators are `aria-hidden`: a screen reader reading "Business slash
 * Abonamente slash Migrare cartelă" is worse than the list structure, which the
 * `<nav>` and the ordered markup already convey.
 */
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'orange-subnav',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="subnav">
      <nav class="crumbs" [attr.aria-label]="label">
        @for (crumb of crumbs(); track crumb; let last = $last) {
          @if (!last) {
            <span>{{ crumb }}</span>
            <span class="sep" aria-hidden="true">/</span>
          } @else {
            <span aria-current="page">{{ crumb }}</span>
          }
        }
      </nav>
    </div>
  `,
  styles: [
    `
      .subnav {
        background: var(--grey-200);
        border-bottom: var(--border-hairline) solid var(--grey-400);
        padding: var(--space-2) var(--gutter);
        display: flex;
        gap: var(--space-3);
        align-items: center;
        flex-wrap: wrap;
        font-size: 11px;
        line-height: 16px;
        font-weight: 700;
      }

      .crumbs {
        display: flex;
        gap: var(--space-2);
        flex-wrap: wrap;
        align-items: center;
      }

      .sep {
        color: var(--grey-700);
        font-weight: 400;
      }
    `,
  ],
})
export class SubnavComponent {
  readonly crumbs = input.required<readonly string[]>();
  readonly label = $localize`:@@crumbs.label:Firimituri`;
}
